export const enum ResponseStatus {
  SUCCESS = 200,
  ACCEPTED = 202,
  MULTIPLE_CHOICES = 300,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  IS_REGISTERED = 409,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
  CANCEL_REQUEST = 499,
  INTERNAL_SERVER = 500,
}

export const enum URL {
  PREMATCH_CATEGORIES = '/api/prematch/categories',
  PREMATCH_CONTENT = '/api/prematch/matches',
  MATCH_RESULT = '/api/match-resulting/results',
  MATCH_RESULT_DETAILS = '/api/match-resulting/match-details',
  MATCH_RESULT_SPORTS = '/api/match-resulting/sports',
  INTERESTING_MATCHES = '/api/matchGroup/interesting-matches',
  PROFILE = '/api/v1/rest/client-profile',
  SAVE_PROFILE_NAME = '/api/v1/rest/client-profile/name',
  SAVE_PROFILE_VAT_NUMBER = '/api/v1/rest/client-profile/vat-number',
  SAVE_PROFILE_CITY = '/api/v1/rest/client-profile/city',
  SAVE_PROFILE_EMAIL = '/api/v1/rest/client-profile/email',
  GEO = '/api/v1/geoinformation',
  CLIENT_PROFILE_LANGUAGE = '/api/v1/rest/client-profile/language',
  ACCOUNT_HISTORY = '/api/v1/account/history',
  ACCOUNT_ENDPOINT = '/api/v3/rest/account/me',
  LIVE_MAIN_LINE = 'api/v1/matchGroup/live-main-line',
  LIVE = 'api/v1/matchGroup/live',
  LIVE_SCHEDULE = '/api/live/schedule',
  EXTERNAL_GAMES = '/api/v1/external-games',
  SITE_CONFIGS = '/api/v1/rest/site-configs',
  SITE_SEARCH = '/api/v1/sitesearch',
  SUPPORT_ISSUE_TOKEN = '/api/v1/support/issue-token',
  REGISTRATION_CHECK_PHONE = '/api/v1/registration/check-phone',
  REGISTRATION_CHECK_CODE = '/api/v2/registration/check-code',
  AUTHENTICATION_CHECK_CODE = '/api/v3/registration/check-code',
  REGISTRATION_SET_PASSWORD = '/api/v1/registration/set-password',
  PASSWORD_RESET_SEND_CODE = '/api/v3/auth/password-reset/send-code',
  PASSWORD_RESET_CHECK_CODE = '/api/v3/auth/password-reset/validate-code',
  PASSWORD_RESET_SEND_NEW_PASS = '/api/v3/auth/password-reset',
  EMAIL_SEND_CODE = '/api/v1/auth/email-confirm/send-code',
  EMAIL_RESEND_CODE = '/api/v1/auth/email-confirm/resend',
  EMAIL_CONFIRM = '/api/v2/auth/email-confirm',
  PHONE_SEND_CODE = '/api/v1/auth/change-phone-number',
  PHONE_CONFIRM = '/api/v2/auth/change-phone-number/confirm',
  CHECK_PROMO_COD = '/api/v1/promo',
  GET_ACTIVE_FREE_BETS = '/api/bet-slip/get-active-free-bets',
  ACTIVE_STAKES = '/api/stakes/briefcase',
  HISTORY_STAKES = '/api/stakes/history',
  MATCH_STATUS = '/api/v1/preMatch',
  GET_STAKE_BALANCE = '/api/stakes/balance',
  CASH_OUT_AMOUNT = '/api/stakes/cashout-amount',
  WITHDRAWAL_ACTIVE= '/api/v1/cash/withdrawal/request/active',
  BIG_STAKES = '/api/stakes/pending',
  CHECK_AVAILABILITY = '/api/v2/bet-slip/get-available-stakes',
  LOGOUT = '/api/v1/auth/logout',
  LOGIN = '/api/v1/auth',
  LOGIN_AFTER_REDIRECT = '/api/v1/auth/redirected',
  CASHBACK_EXPERIENCE_HISTORY = '/api/v1/cashback/exp',
  CASHBACK_DETAILS = '/api/v1/cashback/details',
  NOTIFICATIONS = '/api/v1/notifications',
  AUTH_TELEGRAM_LINK = '/api/v5/auth/telegram-link',
  AUTH_V5 = '/api/v5/auth/',
  NOTIFICATIONS_UNREAD = '/api/v1/notifications/unread',
  NOTIFICATIONS_UNREAD_COUNT = '/api/v1/notifications/unread/count',
  NOTIFICATIONS_MARK_READ_ALL = '/api/v1/notifications/mark-read-all',
  FRESHCHAT_RESTORE_ID = '/api/v1/freshchat/restore-id',
  FAVORITES_CATEGORIES = '/api/v1/rest/favorites/categories',
}
